import React from "react";
import { AlertTriangle } from "lucide-react";

const TXT = {
  de: { red: "Zertifikat gefährdet – Anwesenheit unter 80 %", amber: "Zertifikat-Grenze nah – mind. 80 % Anwesenheit nötig" },
  en: { red: "Certificate at risk – attendance below 80 %", amber: "Close to certificate limit – at least 80 % attendance required" },
};

export function CertRiskBadge({ present = 0, total = 0, lang = "de", testId = "cert-risk-badge" }) {
  if (!total) return null;
  const rate = (present * 100) / total;
  if (rate >= 85) return null;
  const red = rate < 80;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium border ${red ? "bg-red-50 text-red-700 border-red-200" : "bg-amber-50 text-amber-800 border-amber-200"}`}
      data-testid={testId}
      data-level={red ? "red" : "amber"}
    >
      <AlertTriangle size={11} /> {TXT[lang]?.[red ? "red" : "amber"] || TXT.de[red ? "red" : "amber"]}
    </span>
  );
}
